import React from 'react';
import { CodeBlock, CodeTabs } from '@paypalcorp/developeruikit';
import styles from './CodeTabsSection.module.less';
import { trackButtonClick, trackTabClick } from '../../../lib/fpti';

const CodeTabsSection = ({ ecmContent }) => {
  const codeBlocks = ecmContent.codeBlocks;

  if (!codeBlocks) {
    return null;
  }

  return (
    <div className={styles.container}>
      <CodeTabs
        onCodeCopyClick={(_, activeTab) => {
          const activeBlock = codeBlocks?.find((block) => block?.filename === activeTab);
          if (activeBlock) {
            trackButtonClick('Copy', null, activeBlock?.filename);
          }
        }}
        onDownloadClick={(_, activeTab) => {
          const activeBlock = codeBlocks?.find((block) => block?.filename === activeTab);
          if (activeBlock) {
            trackButtonClick('Download', null, activeBlock?.filename);
          }
        }}
        onTabClick={(_, activeTab) => {
          trackTabClick(`${activeTab} tab`);
        }}
      >
        {codeBlocks.map((block, index) => (
          <CodeBlock
            key={index}
            label={block.filename || block.language || `file ${index + 1}`}
            language={block.language}
          >
            {block.code}
          </CodeBlock>
        ))}
      </CodeTabs>
    </div>
  );
};

export default CodeTabsSection;
